import { render, staticRenderFns } from "./block_contactoAdicional_outra.vue?vue&type=template&id=12563061"
import script from "./block_contactoAdicional_outra.vue?vue&type=script&lang=js"
export * from "./block_contactoAdicional_outra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports